<template>
    <div class="nav-header">
        <a href="index.html" class="brand-logo">
         <img src="images/icon.png" style="width: 160px;" alt="img not found">
            <!--<svg class="brand-title" width="87" height="27" viewbox="0 0 87 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.412 20.816V26H0.448V0.439999H18.088V5.624H6.352V10.592H16.432V15.38H6.352V20.816H18.412ZM21.9988 26V0.439999H33.5188C34.7188 0.439999 35.8228 0.691999 36.8308 1.196C37.8628 1.676 38.7508 2.336 39.4948 3.176C40.2388 3.992 40.8148 4.916 41.2228 5.948C41.6548 6.98 41.8708 8.024 41.8708 9.08C41.8708 10.664 41.4868 12.128 40.7188 13.472C39.9748 14.792 38.9668 15.8 37.6948 16.496L43.3108 26H36.7948L31.8988 17.756H27.9028V26H21.9988ZM27.9028 12.608H33.3028C33.9988 12.608 34.5988 12.284 35.1028 11.636C35.6068 10.964 35.8588 10.112 35.8588 9.08C35.8588 8.048 35.5708 7.22 34.9948 6.596C34.4188 5.948 33.7948 5.624 33.1228 5.624H27.9028V12.608ZM64.08 20.816V26H46.116V0.439999H63.756V5.624H52.02V10.592H62.1V15.38H52.02V20.816H64.08ZM83.0028 7.928C82.9308 7.832 82.6788 7.652 82.2468 7.388C81.8148 7.124 81.2748 6.848 80.6268 6.56C79.9788 6.248 79.2708 5.996 78.5028 5.804C77.7348 5.588 76.9668 5.48 76.1988 5.48C74.0868 5.48 73.0308 6.188 73.0308 7.604C73.0308 8.468 73.4868 9.08 74.3988 9.44C75.3348 9.8 76.6668 10.232 78.3948 10.736C80.0268 11.192 81.4308 11.72 82.6068 12.32C83.8068 12.896 84.7308 13.676 85.3788 14.66C86.0268 15.62 86.3508 16.892 86.3508 18.476C86.3508 19.916 86.0868 21.14 85.5587 22.148C85.0308 23.132 84.3108 23.936 83.3987 24.56C82.4868 25.16 81.4548 25.604 80.3028 25.892C79.1748 26.156 77.9988 26.288 76.7748 26.288C74.8788 26.288 72.9588 26.012 71.0148 25.46C69.0708 24.884 67.3548 24.104 65.8668 23.12L68.4588 17.972C68.5548 18.092 68.8668 18.32 69.3948 18.656C69.9228 18.968 70.5828 19.304 71.3748 19.664C72.1668 20.024 73.0308 20.336 73.9668 20.6C74.9268 20.84 75.8988 20.96 76.8828 20.96C78.9708 20.96 80.0148 20.324 80.0148 19.052C80.0148 18.404 79.7388 17.9 79.1868 17.54C78.6588 17.156 77.9268 16.832 76.9908 16.568C76.0548 16.28 74.9988 15.956 73.8228 15.596C71.4708 14.876 69.7308 14 68.6028 12.968C67.4988 11.936 66.9468 10.46 66.9468 8.54C66.9468 6.74 67.3668 5.228 68.2068 4.004C69.0708 2.756 70.2228 1.82 71.6628 1.196C73.1028 0.547999 74.6748 0.223999 76.3788 0.223999C78.1788 0.223999 79.8828 0.535999 81.4908 1.16C83.0988 1.76 84.4668 2.384 85.5948 3.032L83.0028 7.928Z" fill="#3D9662"></path>
            </svg> -->

            <!-- <h3 style="font-size: 28px;
            padding-left: 20px;
            font-weight: 600;
            color: #36C95F;">Hospital</h3> -->
        </a>

        <div class="nav-control">
            <div class="hamburger">
                <span class="line"></span><span class="line"></span><span class="line"></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
name: "NavHeaderPage",
components: {

},
data() {
return {

};
},

created() {
},

computed: {
},

methods: {
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
